import { Container, Row, Col, Nav, Tab, Accordion } from "react-bootstrap";
import { useEffect } from "react";
import useLang from "hooks/useLang";
import barcode from "../../assets/images/services/barcode-accounting.jpeg"
import SideBar from "components/our-services/SideBar";

const AccountingCompliancePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  const { lang } = useLang();
  
  return (
    <Container className="text-muted" style={{ paddingTop: "2rem", marginBottom: "50px" }}>
      <h2>{lang.services.lists.list_2.title}</h2>
      <Tab.Container id="accounting-services" defaultActiveKey="first">
        <Row>
          <Row sm={12} className="justify-center nav-row">
            <Nav variant="pills" className="flex-row services-nav-tab">
              <Nav.Item>
                <Nav.Link className="border-radius-30px" eventKey="first">
                  {lang.services.lists.list_2.nav_1.title}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="border-radius-30px" eventKey="second">
                  {lang.services.lists.list_2.nav_2.title}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="border-radius-30px" eventKey="third">
                  {lang.services.lists.list_2.nav_3.title}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="border-radius-30px" eventKey="fourth">
                  {lang.services.lists.list_2.nav_4.title}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="border-radius-30px" eventKey="fifth">
                  {lang.services.lists.list_2.nav_5.title}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link className="border-radius-30px" eventKey="sixth">
                  {lang.services.lists.list_2.nav_6.title}
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Row>
          <Row>
            <Col>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <h6>{lang.services.lists.list_2.nav_1.sub_title}</h6>
                  {lang.services.lists.list_2.nav_1.paragraphs.map(l => <p>{l}</p>)}
                  <Accordion defaultActiveKey={["0"]}>
                    {lang.services.lists.list_2.nav_1.accordion.map(l => {
                      return <Accordion.Item className="text-muted" eventKey={l.event_key}>
                        <Accordion.Header>{l.header}</Accordion.Header>
                        <Accordion.Body>{l.body}</Accordion.Body>
                      </Accordion.Item>
                    })}
                  </Accordion>
                  <p style={{ marginTop: "20px" }}>
                    {lang.services.lists.list_2.nav_1.closing_paragraph_1}
                  </p>
                  <p>
                    {lang.services.lists.list_2.nav_1.closing_paragraph_2}
                  </p>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  <h6>{lang.services.lists.list_2.nav_2.sub_title}</h6>
                  {lang.services.lists.list_2.nav_2.paragraphs.map(l => <p>{l}</p>)}
                  <Accordion defaultActiveKey={["0"]}>
                    {lang.services.lists.list_2.nav_2.accordion.map(l => {
                      return <Accordion.Item className="text-muted" eventKey={l.event_key}>
                        <Accordion.Header>{l.header}</Accordion.Header>
                        <Accordion.Body>{l.body}</Accordion.Body>
                      </Accordion.Item>
                    })}
                  </Accordion>
                  <p style={{ marginTop: "20px" }}>
                    {lang.services.lists.list_2.nav_2.closing_paragraph}
                  </p>
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  <h6>{lang.services.lists.list_2.nav_3.sub_title}</h6>
                  {lang.services.lists.list_2.nav_3.paragraphs.map(l => <p>{l}</p>)}
                  <Accordion defaultActiveKey={["0"]}>
                    {lang.services.lists.list_2.nav_3.accordion.map(l => {
                      return <Accordion.Item className="text-muted" eventKey={l.event_key}>
                        <Accordion.Header>{l.header}</Accordion.Header>
                        <Accordion.Body>{l.body}</Accordion.Body>
                      </Accordion.Item>
                    })}
                  </Accordion>
                  <p style={{ marginTop: "20px" }}>
                    {lang.services.lists.list_2.nav_3.closing_paragraph_1}
                  </p>
                  <p>
                    {lang.services.lists.list_2.nav_3.closing_paragraph_2}
                  </p>
                </Tab.Pane>
                <Tab.Pane eventKey="fourth">
                  <h6>{lang.services.lists.list_2.nav_4.sub_title}</h6>
                  {lang.services.lists.list_2.nav_4.paragraphs.map(l => <p>{l}</p>)}
                  <Accordion defaultActiveKey={["0"]}>
                    {lang.services.lists.list_2.nav_4.accordion.map(l => {
                      return <Accordion.Item className="text-muted" eventKey={l.event_key}>
                        <Accordion.Header>{l.header}</Accordion.Header>
                        <Accordion.Body>{l.body}</Accordion.Body>
                      </Accordion.Item>
                    })}
                  </Accordion>
                  <p style={{ marginTop: "20px" }}>
                    {lang.services.lists.list_2.nav_4.why_this_is_important}
                  </p>
                  <Accordion defaultActiveKey={["0"]}>
                    {lang.services.lists.list_2.nav_4.accordion_why.map(l => {
                      return <Accordion.Item className="text-muted" eventKey={l.event_key}>
                        <Accordion.Header>{l.header}</Accordion.Header>
                        <Accordion.Body>{l.body}</Accordion.Body>
                      </Accordion.Item>
                    })}
                  </Accordion>
                  <p style={{ marginTop: "20px" }}>
                    {lang.services.lists.list_2.nav_4.closing_paragraph}
                  </p>
                </Tab.Pane>
                <Tab.Pane eventKey="fifth">
                  <h6>{lang.services.lists.list_2.nav_5.sub_title}</h6>
                  {lang.services.lists.list_2.nav_5.paragraphs.map(l => <p>{l}</p>)}
                  <Accordion defaultActiveKey={["0"]}>
                    {lang.services.lists.list_2.nav_5.accordion.map(l => {
                      return <Accordion.Item className="text-muted" eventKey={l.event_key}>
                        <Accordion.Header>{l.header}</Accordion.Header>
                        <Accordion.Body>{l.body}</Accordion.Body>
                      </Accordion.Item>
                    })}
                  </Accordion>
                  <p style={{ marginTop: "20px" }}>
                    {lang.services.lists.list_2.nav_5.advantages}
                  </p>
                  <Accordion defaultActiveKey={["0"]}>
                    {lang.services.lists.list_2.nav_5.accordion_advantages.map(l => {
                      return <Accordion.Item className="text-muted" eventKey={l.event_key}>
                        <Accordion.Header>{l.header}</Accordion.Header>
                        <Accordion.Body>{l.body}</Accordion.Body>
                      </Accordion.Item>
                    })}
                  </Accordion>
                  <p style={{ marginTop: "20px" }}>
                    {lang.services.lists.list_2.nav_5.closing_paragraph}
                  </p>
                </Tab.Pane>
                <Tab.Pane eventKey="sixth">
                  <h6>{lang.services.lists.list_2.nav_6.sub_title}</h6>
                  <p>
                    {lang.services.lists.list_2.nav_6.paragraph_1}
                    <span className="underlined-yellow">
                      {lang.services.lists.list_2.nav_6.paragraph_2}
                    </span>
                    {lang.services.lists.list_2.nav_6.paragraph_3}
                  </p>
                  <p>{lang.services.lists.list_2.nav_6.paragraph_4}</p>
                  <Accordion defaultActiveKey={["0"]}>
                    {lang.services.lists.list_2.nav_6.accordion.map(l => {
                      return <Accordion.Item className="text-muted" eventKey={l.event_key}>
                        <Accordion.Header>{l.header}</Accordion.Header>
                        <Accordion.Body>{l.body}</Accordion.Body>
                      </Accordion.Item>
                    })}
                  </Accordion>
                  <p style={{ marginTop: "20px" }}>
                    {lang.services.lists.list_2.nav_6.closing_paragraph}
                  </p>
                </Tab.Pane>
              </Tab.Content>
            </Col>
            <SideBar barcode={barcode}/>
          </Row>
        </Row>
      </Tab.Container>
    </Container>
  );
};

export default AccountingCompliancePage;
